
function Image (props) {
  const { ...rest } = props;

  return <img {...rest} />
}

export default Image;